import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';

@Component({
  selector: 'app-helpbutton-departments-card',
  templateUrl: './helpbutton-departments-card.component.html',
  styleUrls: ['./helpbutton-departments-card.component.scss']
})
export class HelpbuttonDepartmentsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enabledCount: any;
  disabledCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
  }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('departments-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('departments-counts-spinner');
      this.showCounter = true;
      this.enabledCount = this.data.availableDepartments;
      this.disabledCount = this.data.unavailableDepartments;
    } else if ('-' === this.data) {
      this.enabledCount = '-';
      this.disabledCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('departments-counts-spinner');
    }
  }

}
